import { SailingInterface } from '../interfaces/api';
import * as moment from 'moment-timezone';
import { ShippingLine } from './shipping-line';
import { Timezone } from './timezone';
import { Port } from './port';
import { VehicleType } from './vehicle-type';

export class Sailing implements SailingInterface {

    id: number;

    private _arriving_at: any;

    get arriving_at(): any {
        if (this._arriving_at === undefined || !this._arriving_at) return;
        let arriving_at = moment(this._arriving_at);
        if (this.arrival_timezone) {
            arriving_at.tz(this.arrival_timezone.tz);
        } else if (this.timezone) {
            arriving_at.tz(this.timezone.tz);
        }
        return arriving_at;
    }

    set arriving_at(timestamp: any) {
        this._arriving_at = timestamp;
    }

    private _departing_at: any;

    get departing_at(): any {
        let departing_at = moment(this._departing_at);
        if (this.timezone) departing_at.tz(this.timezone.tz);
        return departing_at;
    }

    set departing_at(timestamp: any) {
        this._departing_at = timestamp;
    }

    shipping_line: ShippingLine;

    timezone: Timezone;

    arrival_timezone: Timezone;

    vehicle_types: VehicleType[];

    static createFromObject(object: any, arrivalPort: Port) {
        let sailing: Sailing = new Sailing();

        if (object.shipping_line !== undefined)
            sailing.shipping_line = ShippingLine.createFromObject(object.shipping_line);

        sailing.vehicle_types = [];
        if (object.vehicle_types !== undefined)
            sailing.vehicle_types = VehicleType.createFromObjects(object.vehicle_types);

        if (object.timezone !== undefined)
            sailing.timezone = Timezone.createFromObject(object.timezone);

        if (arrivalPort !== undefined && arrivalPort.timezone !== undefined)
            sailing.arrival_timezone = arrivalPort.timezone;

        if (object.id !== undefined) sailing.id = object.id;
        if (object.arriving_at !== undefined) sailing.arriving_at = object.arriving_at;
        if (object.departing_at !== undefined) sailing.departing_at = object.departing_at;

        return sailing;
    }

    static createFromObjects(objects: any[], arrivalPortObject: any) {
        let sailings: Sailing[] = [];
        let arrivalPort: Port = Port.createFromObject(arrivalPortObject);

        for (let object of objects) {
            let sailing: Sailing = Sailing.createFromObject(object, arrivalPort);
            sailings.push(sailing);
        }
        return sailings;
    }

}



// WEBPACK FOOTER //
// ./src/entities/sailing.ts